import React, { useEffect, useState, useCallback } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

export default function UsersTab() {
  const [users, setUsers] = useState([]);
  const [neu, setNeu] = useState({ name: "", role: "housekeeping", pin: "" });
  const load = useCallback(() => api.get("/users").then(r => setUsers(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    try {
      await api.post("/users", neu);
      toast.success("Usuario creado");
      setNeu({ name: "", role: "housekeeping", pin: "" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const resetPin = async (u) => {
    const pin = prompt("Nuevo PIN (4-6 dígitos) para " + u.name + ":");
    if (!pin) return;
    try { await api.patch("/users/" + u.id, { pin }); toast.success("PIN actualizado"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const toggle = async (u) => {
    try {
      await api.patch("/users/" + u.id, { disabled: !u.disabled });
      toast.success(u.disabled ? "Activado" : "Desactivado");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const unlock = async (u) => {
    try { await api.post("/users/" + u.id + "/unlock"); toast.success("Rate limit reseteado para la licencia"); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  return (
    <div className="max-w-3xl grid gap-4">
      <div className="q-card p-5">
        <h3 className="font-semibold mb-3">Crear usuario</h3>
        <div className="grid grid-cols-3 gap-2">
          <input placeholder="Nombre" data-testid="new-user-name" value={neu.name} onChange={(e) => setNeu({...neu, name: e.target.value})} className="h-10 px-3 rounded-lg border border-[color:var(--q-border)]"/>
          <select value={neu.role} onChange={(e) => setNeu({...neu, role: e.target.value})} className="h-10 px-3 rounded-lg border border-[color:var(--q-border)]">
            <option value="housekeeping">Housekeeping</option>
            <option value="mantenimiento">Mantenimiento</option>
            <option value="compras">Compras</option>
            <option value="gerencia">Gerencia</option>
          </select>
          <input placeholder="PIN 4-6 dígitos" data-testid="new-user-pin" value={neu.pin} onChange={(e) => setNeu({...neu, pin: e.target.value})} className="h-10 px-3 rounded-lg border border-[color:var(--q-border)] font-mono"/>
        </div>
        <button data-testid="add-user" onClick={add} className="q-btn-primary mt-3">Crear usuario</button>
      </div>
      <div className="q-card p-5">
        <h3 className="font-semibold mb-3">Usuarios del hotel</h3>
        <div className="grid gap-2">
          {users.map(u => (
            <div key={u.id} className="flex items-center gap-3 py-2 border-b border-[color:var(--q-border)]">
              <div className="flex-1">
                <div className={"font-semibold text-sm " + (u.disabled ? "line-through text-[color:var(--q-muted)]" : "")}>{u.name}</div>
                <div className="q-label text-[color:var(--q-muted)]">{u.role}</div>
              </div>
              <button onClick={() => resetPin(u)} className="q-btn-ghost text-xs" data-testid={"reset-pin-" + u.id}>Restablecer PIN</button>
              <button onClick={() => unlock(u)} className="q-btn-ghost text-xs">Desbloquear</button>
              <button onClick={() => toggle(u)} className="q-btn-ghost text-xs">{u.disabled ? "Activar" : "Desactivar"}</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
